<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop></NavTop>
        <!-- 公司 -->
        <div class="gongsi column">
            <!-- 公司顶部 -->
            <div class="gongsi_top column">
                <!-- 搜索 -->
                <div class="main_search_m row" style="margin-left: 0; width: 100%;">
                    <div class="main_search_m_m row">
                        <div class="main_search_m_m_leixing">
                            <div class="zhiweileixingclass">徐州 <i class="el-icon-caret-bottom"></i></div>
                        </div>
                        <input class="main_search_m_m_input" type="text" placeholder="搜索职位公司">
                    </div>
                    <button class="main_search_m_sousuo">搜索</button>
                </div>
                <!-- 搜索 end -->
                <!-- 筛选条件 -->
                <div class="gongsi_top_screen">
                    <img src="@/assets/images/gongsishaixuan.png" alt="" style="width: 100%;">
                </div>
            </div>
            <!-- 公司顶部 end -->
            <!-- 公司内容 -->
            <div class="gongsi_main column">
                <div class="gongsi_main_list row">
                    <div class="gongsi_main_list_m column" v-for="(item, index) in 12" :key="index"
                        @click="goToGongSiDetails(index)">
                        <div class="gongsi_main_list_m_top row">
                            <img src="@/assets/images/qiyelogo2.jpg" class="gongsi_main_list_m_top_img">
                            <div class="gongsi_main_list_m_top_r column">
                                <div class="gongsi_main_list_m_top_r_top">万科物业万科物业万科物业万科物业</div>
                                <div class="gongsi_main_list_m_top_r_bottom row">
                                    <div class="gongsi_main_list_m_top_r_bottom_m">不需要融资不需要融资</div>
                                    <div class="gongsi_main_list_m_top_r_bottom_m">物业管理物业管理</div>
                                </div>
                            </div>
                        </div>
                        <div class="gongsi_main_list_m_bottom row">
                            <!-- <img src="@/assets/images/gongsilistbottom.png" alt="" style="width: 100%;"> -->
                            <div class="gongsi_main_list_m_bottom_hot">热招</div>
                            <div class="gongsi_main_list_m_bottom_geduan"></div>
                            <div class="gongsi_main_list_m_bottom_zhiye">发明专利师发明专利师发明专利师发明专利师发明专利师</div>
                            <div class="gongsi_main_list_m_bottom_gongzi">5-10k</div>
                        </div>
                    </div>
                </div>
                <div class="gongsi_main_fenye">
                    <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
                </div>
                <div class="gongsi_main_bottom">
                    <div class="gongsi_main_bottom_m">
                        <img src="@/assets/images/gongsidibu.png" alt="">
                    </div>
                </div>
            </div>
            <!-- 公司内容 end -->
        </div>
        <!-- 底部 -->
        <Footer></Footer>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'LaGongSiList',
    components: { NavTop, Footer },
    data() {
        return {

        }
    },
    mounted() {

    },
    activated() {

    },
    methods: {
        // 跳转公司详情
        goToGongSiDetails(id) {
            this.$router.push('/gongsi/' + id);
            // const routeData = this.$router.resolve({ path: '/gongsi/' + id });
            // window.open(routeData.href, '_blank');
        }
    }

}
</script>

<style scoped>
.gongsi {
    width: 100%;
    height: auto;
}

.gongsi_top {
    width: 1160px;
    height: auto;
    margin: 20px auto 20px;
    background: #fff;
    border-radius: 10px;
    padding: 20px;
}

.gongsi_top_screen {
    margin-top: 20px;
}

.gongsi_main {
    width: 1200px;
    height: auto;
    margin: 20px auto;
}

.gongsi_main_list {
    width: 1220px;
    height: auto;
    flex-wrap: wrap;
    /* justify-content: space-between; */
}

.gongsi_main_list_m {
    width: 285px;
    height: auto;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 15px;
    margin-right: 20px;
    cursor: pointer;
}

.gongsi_main_list_m:hover {
    box-shadow: 0 16px 40px 0 rgb(138 149 158 / 20%);
    transition: all .4s;
}

.gongsi_main_list_m_top {
    padding: 10px 20px;
    background: #fff;
}

.gongsi_main_list_m_top_img {
    width: 54px;
    height: 54px;
    border-radius: 10px;
    border: solid 1px #f2f5fa;
}

.gongsi_main_list_m_top_r {
    width: 180px;
    margin-left: 10px;
}

.gongsi_main_list_m_top_r_top {
    margin-bottom: 9px;
    color: #222;
    font-weight: 500;
    height: 25px;
    line-height: 25px;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.gongsi_main_list_m_top_r_top:hover {
    color: #00b277;
}

.gongsi_main_list_m_top_r_bottom {}

.gongsi_main_list_m_top_r_bottom_m {
    display: inline-block;
    color: #666;
    padding: 0 8px;
    background: #f8f8f8;
    font-size: 13px;
    border-radius: 4px;
    max-width: 66px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 22px;
    margin-right: 8px;
}

.gongsi_main_list_m_bottom {
    width: calc(100% - 60px);
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    padding: 0 30px;
    color: #666;
    background: linear-gradient(90deg, #f5fcfc 0, #fcfbfa 100%);
    border-radius: 0 0 12px 12px;
    align-items: center;
}

.gongsi_main_list_m_bottom_hot {
    line-height: 48px;
    font-size: 14px;
    color: #666;
}

.gongsi_main_list_m_bottom_geduan {
    width: 1px;
    height: 10px;
    background: #e0e0e0;
    margin: 0 4px;
}

.gongsi_main_list_m_bottom_zhiye {
    color: #00c2b3;
    text-decoration: none;
    display: inline-block;
    vertical-align: top;
    max-width: 145px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.gongsi_main_list_m_bottom_gongzi {
    line-height: 48px;
    font-size: 14px;
    color: #666;
}

.gongsi_main_fenye {
    width: 100%;
    height: auto;
    text-align: center;
    margin: 10px auto 40px;
}

.gongsi_main_bottom {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
}

.gongsi_main_bottom_m {
    padding: 20px;
}
</style>
